import { analytics } from 'analytics';

/*
 * This function tracks the success of a subscription purchase across all of our trackers
 * (Google Ads, Google Analytics, LinkedIn, and Reddit Pixel) which are conditionally set
 * up in Django as well as in analytics set up in React.
 * See Django `checkout_success` method for comparison.
 */
export const trackSubscriptionSuccess = (sessionId: string) => {
  // Extract last 8 characters of the session ID
  const transaction_id = `transaction-${sessionId.slice(-8)}`;
  // Google Ads
  window.gtag?.('event', 'conversion', {
    // send_to consists of two parts (Google Ads ID + conversion label), both of
    // which are safe to expose in JavaScript code according to Github Copilot.
    send_to: 'AW-967884688/bRmuCPibx4gYEJD_ws0D',
    transaction_id,
  });
  // Google Analytics
  window.gtag?.('event', 'purchase', { transaction_id });
  // LinkedIn
  window.lintrk?.('track', { conversion_id: 15901290 });
  // Reddit Pixel
  window.rdt?.('track', 'Purchase');
  // React analytics
  analytics.track('Conversion Modal - Subscription Success', {
    transaction_id,
  });
};
